<script setup lang="ts">
import { useForwardProps } from 'reka-ui'

import { Box, type BoxProps } from '@/components'

import * as styles from './VisuallyHidden.css'

export interface VisuallyHiddenProps extends BoxProps {}

const props = defineProps<VisuallyHiddenProps>()
const forwarded = useForwardProps(props)
</script>

<template>
  <Box v-bind="forwarded" :class="styles.visuallyHidden">
    <slot />
  </Box>
</template>
